import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import Form from '../../../../components/Form'
import Field from '../../../../components/Form/Field'
import Icon from '../../../../components/Icon'

import { ReactComponent as PicturesLogo } from '../../../../assets/icons/pictures-logo.svg'

import { clearAddAccessibleSocialPages } from '../../../../modules/actions/socialAccounts'
import {
  addAccessibleSocialPagesErrorSelector,
  addAccessibleSocialPagesIsLoadingSelector,
  addAccessibleSocialPagesWasCreatedSelector
} from '../../../../modules/selectors/socialAccounts'

import { PAGE_ID } from './fields'
import { ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK, ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK } from '../../../../constants/forms'
import { FACEBOOK_PROVIDER_PLATFORM, TIKTOK_PROVIDER_PLATFORM } from '../../../../constants/selectLists/platformList'

import useStyles from './styles'
import useDrawerFormClasses from '../../../../styles/common/drawerForms'

const AddPagesForm = ({ formik, pagesOptions, provider }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const drawerFormClasses = useDrawerFormClasses()

  const wasPageAdded = useSelector(addAccessibleSocialPagesWasCreatedSelector)

  const { t } = useTranslation()

  const clearAddSocialPageHandler = useCallback(() => {
    dispatch(clearAddAccessibleSocialPages())
  }, [dispatch])

  const formName = useMemo(() => {
    if (provider === FACEBOOK_PROVIDER_PLATFORM) {
      return ACCESSIBLE_SOCIAL_PAGE_ADD_FACEBOOK
    } else if (provider === TIKTOK_PROVIDER_PLATFORM) {
      return ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK
    }
  }, [provider])

  const title = useMemo(() => {
    if (provider === FACEBOOK_PROVIDER_PLATFORM) {
      return t('Select Facebook page')
    } else if (provider === TIKTOK_PROVIDER_PLATFORM) {
      return t('Select TikTok identity')
    } else {
      return ''
    }
  }, [provider, t])

  const placeholder = useMemo(() => {
    if (provider === FACEBOOK_PROVIDER_PLATFORM) {
      return t('Select Facebook page')
    } else if (provider === TIKTOK_PROVIDER_PLATFORM) {
      return t('Select TikTok identity')
    } else {
      return t('Select page')
    }
  }, [provider, t])

  return (
    <Form
      formName={formName}
      formik={formik}
      successSubmit={wasPageAdded}
      errorSelector={addAccessibleSocialPagesErrorSelector}
      isLoadingSelector={addAccessibleSocialPagesIsLoadingSelector}
      clearHandler={clearAddSocialPageHandler}
      submitText="Add"
    >
      <section className={drawerFormClasses.section}>
        <h3 className={drawerFormClasses.sectionTitle}>{title}</h3>
        <Field
          placeholder={placeholder}
          formik={formik}
          name={PAGE_ID}
          options={pagesOptions}
          Icon={
            <Icon className={classes.picturesLogo}>
              <PicturesLogo />
            </Icon>
          }
        />
      </section>
    </Form>
  )
}

AddPagesForm.propTypes = {
  formik: PropTypes.object.isRequired,
  pagesOptions: PropTypes.array.isRequired,
  provider: PropTypes.string.isRequired
}
export default AddPagesForm
